/* KOJI CHAT - accessibilita' e mobile (si aggiunge a koji-chat.js, agisce per delega sugli eventi) */
(function () {
  if (window.__kcA11y) return;
  window.__kcA11y = true;
  var mq = window.matchMedia ? window.matchMedia('(max-width: 768px)') : { matches: false };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function openBtn(root) { return root ? root.querySelector('[data-kc="sheet-open"]') : null; }

  var vtOK = !reduce && typeof document.startViewTransition === 'function';
  var bypass = false;

  /* L'animazione a "ritaglio" del motore causava scatti in chiusura: la sostituisco con una transizione continua (View Transitions)
     o, dove non esiste, con una dissolvenza. Il motore continua a fare tutto il resto (stato, focus, tastiera, cronologia). */
  (function () {
    var orig = Element.prototype.animate;
    if (!orig) return;
    Element.prototype.animate = function (kf) {
      if (this.classList && this.classList.contains('kc-panel') && Array.isArray(kf) && kf[0] && kf[0].clipPath) {
        var a = {
          cancel: function () {}, finish: function () {}, play: function () {},
          set onfinish(fn) { if (typeof fn === 'function') { try { fn.call(a); } catch (err) { /* ok */ } } },
          set oncancel(fn) {}
        };
        return a;
      }
      return orig.apply(this, arguments);
    };
  })();

  function engineClick(btn) {
    bypass = true;
    try { btn.click(); } finally { bypass = false; }
  }
  function fade(panel, dir) {
    if (!panel || reduce || !panel.animate) return;
    panel.animate(
      dir === 'open' ? [{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }] : [{ opacity: 0 }, { opacity: 1 }],
      { duration: dir === 'open' ? 260 : 200, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
    );
  }
  function sheetRun(root, dir, btn, viaVT) {
    if (!btn) return;
    var panel = root.querySelector('.kc-panel');
    var sc = root.querySelector('.kc-scroll');
    var de = document.documentElement;
    var y = window.scrollY || 0;
    var post = function () {
      if (sc) sc.scrollTop = root.querySelector('.kc-sort [data-sort="top"][aria-pressed="true"]') ? 0 : sc.scrollHeight;
      if (dir === 'close' && Math.abs((window.scrollY || 0) - y) > 1) window.scrollTo(0, y);
    };
    var go = function () { engineClick(btn); post(); };
    if (!viaVT || !vtOK || !panel) { go(); fade(panel, dir); return; }
    if (de.classList.contains('kc-vt-run')) return;
    root.classList.add('kc-vt');
    de.classList.add('kc-vt-run', 'kc-vt-' + dir);
    var end = function () { root.classList.remove('kc-vt'); de.classList.remove('kc-vt-run', 'kc-vt-' + dir); };
    var t = null;
    try { t = document.startViewTransition(go); } catch (err) { t = null; }
    if (t) { t.finished.then(end, end); return; }
    end();
    go(); fade(panel, dir);
  }

  /* aprire / chiudere la chat a schermo intero (mobile) */
  document.addEventListener('click', function (e) {
    if (bypass || !mq.matches) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest('[data-koji-chat]');
    if (!root || root.classList.contains('kc--hub')) return;
    var isOpen = root.classList.contains('is-open');
    var openB = openBtn(root);
    var closeB = root.querySelector('[data-kc="sheet-close"]');
    if (t.closest('[data-kc="open-full"]') || t.closest('[data-kc="sheet-open"]')) {
      if (isOpen) return;
      e.preventDefault(); e.stopPropagation();
      sheetRun(root, 'open', openB, true);
      return;
    }
    if (t.closest('[data-kc="sheet-close"]')) {
      if (!isOpen) return;
      e.preventDefault(); e.stopPropagation();
      sheetRun(root, 'close', closeB, true);
      return;
    }
    if (!isOpen && t.closest('.kc-feed') && !t.closest('button, a, textarea, [data-action], .kc-opts')) {
      e.stopPropagation();
      sheetRun(root, 'open', openB, true);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var root = document.querySelector('.kc.is-open');
    if (!root || document.querySelector('dialog[open]')) return;
    if (root.querySelector('.kc-emoji-panel:not([hidden]), .kc-menu:not([hidden])')) return;
    if (e.target && e.target.matches && e.target.matches('[data-kc="textarea"]') && root.querySelector('.kc-reply-ctx:not([hidden])')) return;
    e.stopPropagation();
    sheetRun(root, 'close', root.querySelector('[data-kc="sheet-close"]'), true);
  }, true);

  /* mobile: scrivere dalla chat in linea apre la schermata intera, cosi' la tastiera non copre nulla */
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-kc="textarea"]') || !mq.matches) return;
    var root = t.closest('[data-koji-chat]');
    if (!root || root.classList.contains('is-open') || root.classList.contains('kc--hub')) return;
    var o = openBtn(root);
    if (!o) return;
    sheetRun(root, 'open', o, false);
    try { t.focus({ preventScroll: true }); } catch (err) { /* ok */ }
  });

  /* ruoli e stato della schermata intera */
  function sync() {
    var hubEl = document.querySelector('[data-kh]');
    if (hubEl) {
      var full = hubEl.classList.contains('kh-full');
      var c = hubEl.querySelector('.kh-center');
      var xb = hubEl.querySelector('.kh-expand');
      if (xb) xb.setAttribute('aria-expanded', full ? 'true' : 'false');
      if (c) {
        if (full) { c.setAttribute('role', 'dialog'); c.setAttribute('aria-modal', 'true'); c.setAttribute('aria-label', (hubEl.querySelector('.kc-title') || {}).textContent || 'Chat'); }
        else if (c.getAttribute('role') === 'dialog') { c.removeAttribute('role'); c.removeAttribute('aria-modal'); c.removeAttribute('aria-label'); }
      }
    }
    document.querySelectorAll('[data-koji-chat]').forEach(function (root) {
      var open = root.classList.contains('is-open');
      var btn = openBtn(root);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var p = root.querySelector('.kc-panel');
      if (!p) return;
      if (open) {
        p.setAttribute('role', 'dialog');
        p.setAttribute('aria-modal', 'true');
        p.setAttribute('aria-label', root.getAttribute('aria-label') || 'Chat');
      } else if (p.getAttribute('role') === 'dialog') {
        p.removeAttribute('role');
        p.removeAttribute('aria-modal');
        p.removeAttribute('aria-label');
      }
    });
  }
  if (window.MutationObserver) new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  /* Scroll-lock senza salti: html{overflow:hidden} su mobile puo' allargare il viewport (contenuti larghi dello slider)
     e fa perdere lo scroll. Si blocca il body in position:fixed e si ripristina la posizione esatta alla chiusura. */
  var lockY = null;
  function lockSync() {
    var de = document.documentElement, on = de.classList.contains('kc-lock'), b = document.body;
    if (on && lockY === null && de.clientWidth <= 768) {
      lockY = window.pageYOffset || de.scrollTop || 0;
      b.style.position = 'fixed'; b.style.top = (-lockY) + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
      de.style.overflow = 'visible';
    } else if (!on && lockY !== null) {
      var y = lockY; lockY = null;
      b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
      de.style.overflow = '';
      var sb = de.style.scrollBehavior; de.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      de.style.scrollBehavior = sb;
    }
  }
  if (window.MutationObserver) new MutationObserver(lockSync).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  sync();

  /* Messaggi compatti su mobile: la riga "in risposta a" resta solo per i lettori di schermo quando il messaggio e' gia' sotto il suo originale;
     i testi molto lunghi si accorciano con "Leggi tutto". */
  var openIds = new Set(), longIds = new Set(), scanTimer = null;
  function scan() {
    scanTimer = null;
    document.querySelectorAll('[data-koji-chat] .kc-thread').forEach(function (th) {
      var key = th.getAttribute('data-key');
      th.querySelectorAll('.kc-replyto').forEach(function (b) { b.classList.toggle('kc-replyto--root', b.getAttribute('data-id') === key); });
    });
    document.querySelectorAll('[data-koji-chat] .kc-like-count').forEach(function (n) { if (n.textContent.trim() === '0') n.setAttribute('data-zero', ''); else n.removeAttribute('data-zero'); });
    var on = mq.matches;
    document.querySelectorAll('[data-koji-chat] .kc-item .kc-text').forEach(function (t) {
      var body = t.parentNode, btn = body.querySelector(':scope > .kc-readmore');
      if (!on || t.classList.contains('kc-text--spoiler') || t.closest('.kc-ghost')) {
        t.classList.remove('kc-clamp'); if (btn) btn.remove(); return;
      }
      var item = t.closest('.kc-item'), id = item ? item.id : '';
      if (!id) return;
      var expanded = openIds.has(id);
      if (expanded) t.classList.remove('kc-clamp');
      else {
        t.classList.add('kc-clamp');
        if (t.offsetParent !== null) {
          if (t.scrollHeight > t.clientHeight + 2) longIds.add(id); else longIds.delete(id);
        }
      }
      var need = expanded || longIds.has(id);
      if (need && !btn) {
        btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'kc-readmore';
        t.insertAdjacentElement('afterend', btn);
      }
      if (!need && btn) { btn.remove(); return; }
      if (btn) {
        var label = expanded ? 'Mostra meno' : 'Leggi tutto';
        if (btn.textContent !== label) btn.textContent = label;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    });
  }
  /* pagina chat su mobile: il conteggio va accanto al titolo e "Regole" accanto ai comandi (si rimettono al loro posto su desktop) */
  function placeHead(root) {
    var head = root.querySelector('.kc-head');
    if (!head) return;
    var count = head.querySelector('.kc-count'), rules = head.querySelector('[data-kc="rules-btn"]');
    var titles = head.querySelector('.kc-titles'), main = head.querySelector('.kc-head-main');
    var tb = head.querySelector('.kc-toolbar'), tbr = head.querySelector('.kc-toolbar-right');
    if (!count || !rules || !titles || !main || !tb || !tbr) return;
    var compact = mq.matches && root.classList.contains('kc--hub');
    if (compact && root.getAttribute('data-kc-head') !== '1') {
      var badge = titles.querySelector('.kc-badge');
      titles.insertBefore(count, badge || null);
      main.insertBefore(rules, titles.nextSibling);
      root.setAttribute('data-kc-head', '1');
    } else if (!compact && root.getAttribute('data-kc-head') === '1') {
      tb.insertBefore(count, tb.firstChild);
      tbr.appendChild(rules);
      root.removeAttribute('data-kc-head');
    }
    head.querySelectorAll('.kc-rules-btn').forEach(function (b) {
      if (!b.getAttribute('title')) { var t = (b.textContent || '').trim(); if (t) b.setAttribute('title', t); }
    });
  }
  function placeAll() { document.querySelectorAll('[data-koji-chat]').forEach(placeHead); }
  placeAll();
  if (mq.addEventListener) mq.addEventListener('change', placeAll);
  function schedScan() { if (!scanTimer) scanTimer = setTimeout(scan, 90); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.kc-readmore');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var item = b.closest('.kc-item'); if (!item) return;
    if (openIds.has(item.id)) {
      openIds.delete(item.id); scan();
      var sc = item.closest('.kc-scroll');
      if (sc) { var r = item.getBoundingClientRect(), sr = sc.getBoundingClientRect(); if (r.top < sr.top) sc.scrollTop -= (sr.top - r.top) + 8; }
    } else { openIds.add(item.id); scan(); }
  }, true);
  document.querySelectorAll('[data-koji-chat]').forEach(function (r) {
    if (window.MutationObserver) new MutationObserver(schedScan).observe(r, { childList: true, subtree: true });
    r.addEventListener('kc:ready', schedScan);
  });
  window.addEventListener('resize', schedScan);
  if (mq.addEventListener) mq.addEventListener('change', schedScan);
  if (window.MutationObserver) new MutationObserver(schedScan).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  document.querySelectorAll('[data-kh]').forEach(function (h) { if (window.MutationObserver) new MutationObserver(schedScan).observe(h, { attributes: true, attributeFilter: ['data-view'] }); });
  schedScan(); setTimeout(scan, 1200);

  /* il focus resta dentro la schermata intera */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var root = document.querySelector('.kc.is-open');
    var hb = document.querySelector('.kh.kh-full');
    if ((!root && !hb) || document.querySelector('dialog[open]')) return;
    var panel = root ? root.querySelector('.kc-panel') : hb.querySelector('.kh-center');
    if (!panel) return;
    var f = Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled]), textarea:not([disabled]), [tabindex="0"]'), function (n) {
      return !n.closest('[hidden]') && n.offsetParent !== null;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], ae = document.activeElement;
    if (e.shiftKey && (ae === first || !panel.contains(ae))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (ae === last || !panel.contains(ae))) { e.preventDefault(); first.focus(); }
  });

  /* collezione: il bottone "COMMENTA ..." porta alla chat e sposta il focus li' */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#koji-scroll-to-chat');
    if (!b) return;
    var root = document.getElementById('koji-comments-section');
    if (!root) return;
    if (root.scrollIntoView && !e.defaultPrevented) root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    setTimeout(function () { try { root.focus({ preventScroll: true }); } catch (err) { /* ok */ } }, reduce ? 50 : 700);
  });
  /* ---- pagina Chat (hub) ---- */
  var hub = document.querySelector('[data-kh]');
  if (hub) {
    /* elenco stanze: pulsanti veri, non "listitem" */
    var list = hub.querySelector('[data-kh="list"]');
    if (list) {
      var fixRoles = function () {
        if (list.getAttribute('role') !== 'group') list.setAttribute('role', 'group');
        list.querySelectorAll('[role="listitem"]').forEach(function (n) { n.removeAttribute('role'); });
      };
      fixRoles();
      if (window.MutationObserver) new MutationObserver(fixRoles).observe(list, { childList: true });
    }
    /* il focus segue la vista su mobile */
    if (window.MutationObserver) {
      var lastView = hub.getAttribute('data-view');
      new MutationObserver(function () {
        var v = hub.getAttribute('data-view');
        if (v === lastView) return;
        lastView = v;
        if (!mq.matches) return;
        requestAnimationFrame(function () {
          var t = null;
          if (v === 'chat') { t = hub.querySelector('.kc-title'); if (t) t.setAttribute('tabindex', '-1'); }
          else if (list) t = list.querySelector('[aria-current="true"]') || list.querySelector('button');
          if (t) { try { t.focus({ preventScroll: true }); } catch (err) { /* ok */ } }
        });
      }).observe(hub, { attributes: true, attributeFilter: ['data-view'] });
    }
    /* il login riporta alla stanza aperta */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.kh a.kc-guest');
      if (!a) return;
      var base = (a.getAttribute('href') || '').split('return_url=')[0];
      if (base) a.setAttribute('href', base + 'return_url=' + encodeURIComponent(location.pathname + location.search));
    }, true);
    /* header del sito (fisso in alto su mobile): la chat parte sempre sotto, anche con notch o barra alta */
    var baseTop = parseFloat(hub.style.getPropertyValue('--kh-top-m')) || 92;
    var fitTop = function () {
      var hd = document.querySelector('.koji-mob-top');
      var need = 0;
      if (mq.matches && hd) { var r = hd.getBoundingClientRect(); if (r.height > 0) need = Math.ceil(r.bottom) + 12; }
      hub.style.setProperty('--kh-top-m', Math.max(baseTop, need) + 'px');
      /* isole in basso: la chat finisce sopra, tranne con la tastiera aperta (le isole restano nascoste dietro) */
      var bt = document.querySelector('.koji-mob-bottom');
      var needB = 12;
      var vvh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      var kb = vvh < window.innerHeight - 120;
      if (mq.matches && bt && !kb) { var rb = bt.getBoundingClientRect(); if (rb.height > 0) needB = Math.max(12, Math.ceil(window.innerHeight - rb.top) + 10); }
      hub.style.setProperty('--kh-bot-m', needB + 'px');
    };
    fitTop();
    window.addEventListener('resize', fitTop);
    window.addEventListener('orientationchange', fitTop);
    if (window.visualViewport) window.visualViewport.addEventListener('scroll', fitTop);
    /* ---- schermo intero (mobile) ---- */
    var hubFull = false, hubScrollY = 0;
    var ICON_OPEN = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line></svg>';
    var ICON_CLOSE = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
    var headMain = hub.querySelector('.kc-head-main');
    var expandBtn = document.createElement('button');
    expandBtn.type = 'button'; expandBtn.className = 'kh-expand';
    expandBtn.setAttribute('aria-haspopup', 'dialog'); expandBtn.setAttribute('aria-expanded', 'false');
    expandBtn.setAttribute('aria-label', 'Apri la chat a schermo intero'); expandBtn.innerHTML = ICON_OPEN;
    var collapseBtn = document.createElement('button');
    collapseBtn.type = 'button'; collapseBtn.className = 'kh-collapse';
    collapseBtn.setAttribute('aria-label', 'Chiudi lo schermo intero'); collapseBtn.innerHTML = ICON_CLOSE;
    if (headMain) { headMain.appendChild(expandBtn); headMain.appendChild(collapseBtn); }

    var runMorph = function (dir, mutate) {
      var de = document.documentElement;
      var center = hub.querySelector('.kh-center');
      if (vtOK && center) {
        if (de.classList.contains('kc-vt-run')) { setTimeout(function () { runMorph(dir, mutate); }, 60); return; }
        hub.classList.add('kc-vt');
        de.classList.add('kc-vt-run', 'kc-vt-' + dir);
        var end = function () { hub.classList.remove('kc-vt'); de.classList.remove('kc-vt-run', 'kc-vt-' + dir); };
        var t = null;
        try { t = document.startViewTransition(mutate); } catch (err) { t = null; }
        if (t) { t.finished.then(end, end); return; }
        end();
      }
      mutate();
      if (center && !reduce && center.animate) {
        center.animate(dir === 'open' ? [{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }] : [{ opacity: 0 }, { opacity: 1 }], { duration: dir === 'open' ? 260 : 200, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
      }
    };
    var toEnd = function (was) {
      var sc = hub.querySelector('.kc-scroll');
      if (sc && was) sc.scrollTop = sc.scrollHeight;
    };
    var nearEnd = function () {
      var sc = hub.querySelector('.kc-scroll');
      return !sc || sc.scrollHeight - sc.scrollTop - sc.clientHeight < 80;
    };
    var setFull = function (on, instant) {
      if (on === hubFull) return;
      if (on && (!mq.matches || hub.getAttribute('data-view') !== 'chat')) return;
      hubFull = on;
      var was = nearEnd();
      var de = document.documentElement;
      if (on) {
        hubScrollY = window.scrollY || 0;
        var open = function () {
          hub.classList.add('kh-full');
          de.classList.add('kc-lock');
          fit();
          toEnd(was);
          if (document.activeElement && document.activeElement.tagName !== 'TEXTAREA') collapseBtn.focus({ preventScroll: true });
        };
        runMorph('open', open);
      } else {
        var close = function () {
          hub.classList.remove('kh-full');
          de.classList.remove('kc-lock');
          fit();
          toEnd(was);
          if (Math.abs((window.scrollY || 0) - hubScrollY) > 1) window.scrollTo(0, hubScrollY);
          if (mq.matches) expandBtn.focus({ preventScroll: true });
        };
        if (instant) close(); else runMorph('close', close);
      }
    };
    expandBtn.addEventListener('click', function () { setFull(true); });
    collapseBtn.addEventListener('click', function () { setFull(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !hubFull || document.querySelector('dialog[open]')) return;
      if (hub.querySelector('.kc-emoji-panel:not([hidden]), .kc-menu:not([hidden])')) return;
      if (e.target && e.target.matches && e.target.matches('[data-kc="textarea"]') && hub.querySelector('.kc-reply-ctx:not([hidden])')) return;
      setFull(false);
    }, true);
    if (window.MutationObserver) {
      new MutationObserver(function () { if (hubFull && hub.getAttribute('data-view') !== 'chat') setFull(false, true); }).observe(hub, { attributes: true, attributeFilter: ['data-view'] });
    }
    mq.addEventListener && mq.addEventListener('change', function () { if (!mq.matches && hubFull) setFull(false, true); });

    /* tastiera su mobile: il pannello segue l'altezza visibile */
    var vv = window.visualViewport;
    var fit = function () {
      if (!mq.matches) { hub.style.removeProperty('--kh-vh'); hub.style.removeProperty('--kh-vvtop'); return; }
      if (vv) {
        hub.style.setProperty('--kh-vh', Math.round(vv.height) + 'px');
        hub.style.setProperty('--kh-vvtop', Math.round(vv.offsetTop) + 'px');
      }
      fitTop();
      var ae = document.activeElement;
      if (!hubFull && vv && ae && /TEXTAREA|INPUT/.test(ae.tagName) && vv.height < window.innerHeight - 120) hub.scrollIntoView({ block: 'start' });
    };
    if (vv) {
      vv.addEventListener('resize', fit);
      vv.addEventListener('scroll', function () { if (hubFull && vv) hub.style.setProperty('--kh-vvtop', Math.round(vv.offsetTop) + 'px'); });
    }
    fit();
  }
})();
